import { DataType } from '../../enums/shared/enums';

export function ColumnType(type: DataType) {
    return Reflect.metadata('column-type', type);
}
